import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatInputModule } from '@angular/material/input';
import { NvDropdownItemModule } from '../nv-dropdown-item/nv-dropdown-item.module';
import { NvPillButtonModule } from '../nv-pill-button/nv-pill-button.module';
import { NvDropdownComponent } from './nv-dropdown.component';
import { NvIconModule } from '../nv-icon/nv-icon.module';

@NgModule({
  imports: [CommonModule, NvPillButtonModule, NvDropdownItemModule, MatMenuModule, MatInputModule, NvIconModule],
  declarations: [NvDropdownComponent],
  exports: [NvDropdownComponent],
})
export class NvDropdownModule {}
